import { Badge } from "@/components/ui/badge";
import { ChevronDown, ChevronUp } from "lucide-react";
import type { OrderStatus } from "./types";

interface StatusBadgeProps {
    status: OrderStatus;
    isExpanded?: boolean;
    showChevron?: boolean;
}

export function StatusBadge({ status, isExpanded, showChevron = true }: StatusBadgeProps) {
    const STATUS_COLORS = {
        orange: `bg-[#F59E0B] bg-opacity-10 text-amber-500 cursor-pointer`,
        red: "bg-red-50 text-red-600 border-red-100 cursor-pointer",
        blue: "bg-[#F59E0B] bg-opacity-10 text-amber-500 cursor-pointer",
        green: "bg-green-50 text-green-600 border-green-100 cursor-pointer",
    };

    {
        /** TODO: Bug Fix for TS Error on line 26 */ 
    }
    return (
        <Badge
            variant="default"
            className={`${STATUS_COLORS[status?.color as keyof typeof STATUS_COLORS]} text-nowrap text-xs font-regular`}
        >
            {status?.label}
            {showChevron &&
                (isExpanded ? (
                    <ChevronUp className="ml-1 h-4 w-4 text-black" />
                ) : (
                    <ChevronDown className="ml-1 h-4 w-4 text-black" />
                ))}
        </Badge>
    );
}
